<template>
  <v-list dense>
    <template v-for="(item, index) in items">
      <v-list-item v-if="item.heading" :key="item.heading" class="my-2" :ripple="{ center: true }">
        <v-list-item-content>
          <v-list-item-title>
            <span><strong>{{ item.heading }}</strong></span>
          </v-list-item-title>
          <v-list-item-subtitle v-if="item.subtitle">
            <span>{{ item.subtitle }}</span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-else :key="item.title" :ripple="{ center: true }" @click="emitAction(item.action, $event)">
        <v-list-item-content>
          <span class="pl-2">{{ item.title }}</span>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="divider" :key="index" v-if="!item.heading && index + 1 < items.length"></v-divider>
    </template>
  </v-list>
</template>

<script>
export default {
  name: 'TopNavPullDown',
  props: ['navItems'],
  data () {
    return {
      items: this.navItems
    }
  },
  methods: {
    emitAction(action) {
      if (action) {
        this.$eventHub.$emit(action)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .divider {
    width:90%;
    margin-left: 15px;
  }
</style>
